import React, { useContext, useState } from "react";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../Context/Context";
import toast, { Toaster } from "react-hot-toast";
import { loginUser } from "../Api";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

const SignIn = () => {
  const { setUser } = useContext(AppContext);
  const [pwd, setPwd] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center h-screen bg-slate-200 ">
      <Toaster position="top-center" reverseOrder={false} />
      <Formik
        initialValues={{ email: "", password: "" }}
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = "Required Email-address";
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = "Invalid email address";
          }
          if (!values.password) {
            errors.password = "Required password";
          } else if (
            !/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/i.test(
              values.password
            )
          ) {
            errors.password =
              "Minimum 8 and maximum 16 characters, at least one uppercase letter, one lowercase letter, one number and one special character";
          }
          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const { email, password } = values;
          const payload = { email, password };

          const {success,data,error} = await loginUser(payload);
          const userData = data?.data;
          if (success && userData) {
            toast.success(data?.message);
            localStorage.setItem("userInfo", JSON.stringify(userData));
            setUser(userData);
            setTimeout(() => {navigate("/");}, 1000);
          } else {
            console.error("Login failed:", error || "Unknown error");
            toast.error(error);
            navigate("/login");
          }
          setSubmitting(false);

        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form
            className="bg-gray-100 shadow-lg shadow-blue-500/50 border rounded-md flex flex-col w-[30%] p-4 justify-around h-[60%]"
            onSubmit={handleSubmit}
          >
            <h1 className="text-2xl flex justify-center font-semibold">
              LOGIN
            </h1>
            <div>
              <input
                className="outline-none p-1.5 border-b w-full placeholder:italic border-orange-300 rounded-md"
                id="email"
                type="email"
                name="email"
                placeholder="Email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
              />
              <p className=" text-red-600 text-xs font-semibold text-left">
                {errors.email && touched.email && errors.email}
              </p>
              <div className=" mt-2 flex items-center bg-white border-b  border-orange-300   rounded-lg p-1">
                <input
                  className="outline-none p-0.5   placeholder:italic  w-full"
                  type={pwd ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                />
                <span className="  px-1" onClick={() => setPwd(!pwd)}>
                  {!pwd ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <p className=" text-red-600 text-xs font-semibold text-left mt-2">
                {errors.password && touched.password && errors.password}
              </p>
            </div>

            <button
              className="bg-blue-950  text-white drop-shadow-2xl rounded-md py-2 px-4"
              type="submit"
              disabled={isSubmitting}
            >
              Sign-In
            </button>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default SignIn;
